export default __webpack_public_path__ + "img/richrank-41ec577d.png";